var timer;
function checkForm(type,elem,fieldname,from, blockMenuTopConnexionInfobulle ) {
	if(blockMenuTopConnexionInfobulle == undefined) {blockMenuTopConnexionInfobulle = 0;};
	if( from != 'click' ){
		elementID = elem.id;
	}else{
		elementID = elem;
	}
	var already_mail = false;
	if( elem == 'clientCivilite' ) elementID = elem;
	switch(type){
		case"prix":
			var flag = verif_price(elementID,fieldname);
			break;
		case 'alpha':
			var flag = verif_alpha(elementID,fieldname,false);
			break;
		case 'alpha_optional':
			var flag = true;
			if( document.getElementById(elementID).value != '' ) flag = verif_alpha(elementID,fieldname,false);
			break;
		case 'alphanum':
			var flag = verif_alphanum(elementID,fieldname,false);
			break;
		case 'alphanumadresse':
			var flag = verif_alphanumadresse(elementID,fieldname,false);
			break;
		case 'alphanum_optional':
			var flag = true;
			if( document.getElementById(elementID).value != '' ) {
				if(fieldname.indexOf('|')!=-1){
					length = fieldname.substring(fieldname.indexOf('|')+1);
					fieldname = fieldname.substring(0,fieldname.indexOf('|'));
					flag = verif_alphanum(elementID,fieldname,true,length);
				}
				else flag = verif_alphanum(elementID,fieldname,false);
			}
			break;
		case 'same':
			elemCmpID = elementID.substring(0,elementID.length-1);
			var flag = verif_alphanum(elementID,fieldname,false);
			if( flag ) flag = verifSame( elemCmpID, elementID, fieldname );
			break;
		case 'same_optional':
			var flag = true;
			elemCmpID = elementID.substring(0,elementID.length-1);
			if( document.getElementById(elementID).value != '' || document.getElementById(elemCmpID).value != ''  ) {
				var flag = verif_alphanum(elementID,fieldname,false);
				if( flag ) flag = verifSame( elemCmpID, elementID, fieldname );
			}
			break;
		case 'mail':
			var flag = verif_mail(elementID,fieldname);
			break;
		case 'mail_log':
			var flag = verif_mail(elementID,fieldname);
			if( flag ) {
				var action = $("#" + elementID).closest('form').attr('action');
				flag = ajax_file(path_relative_root + 'ajax_email_exist.php?mail='+document.getElementById(elementID).value+ '&action='+action);
				var flag_ret = flag;
				if( flag == '1' || flag == '2' ) flag = false;
				else flag = true;
				if( !flag ) {
					var objElement = document.getElementById(elementID);
					var objLabel = document.getElementById(elementID + 'Label');
					var erreurText = document.getElementById('erreur_msg');
					if ( flag_ret == '1')
						erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root +'ajax_sprintf.php?arg1='+fieldname) + ' :</p>' + ajax_file(path_relative_root +'ajax_sprintf.php?arg1=js_already_mail');
					else
						erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file(path_relative_root +'ajax_sprintf.php?arg1='+fieldname) + ' :</p>' + ajax_file(path_relative_root +'ajax_sprintf.php?arg1=login_erreur_17');
					objElement.className = 'inputErr';
					if(objLabel){
						objLabel.className = 'labelErr';
					}
					already_mail = true;
				}
			}
			break;
		case 'mail_log_info':
			var flag = verif_mail(elementID,fieldname);
			if( flag && ( document.getElementById(elementID).value != document.getElementById('old_clientMail').value ) ) {
				flag = ajax_file('ajax_email_exist.php?mail='+document.getElementById(elementID).value);
				if( flag == '1' ) flag = false;
				else flag = true;
				if( !flag ) {
					var objElement = document.getElementById(elementID);
					var objLabel = document.getElementById(elementID + 'Label');
					var erreurText = document.getElementById('erreur_msg');
					erreurText.innerHTML = '<p class="title_toolltip">' + ajax_file('ajax_sprintf.php?arg1='+fieldname) + ' :</p>' + ajax_file('ajax_sprintf.php?arg1=js_already_mail_short');
					objElement.className = 'inputErr';
					objLabel.className = 'labelErr';
					already_mail = true;
				}
			}
			break;
		case 'mail_verif':
			elemCmpID = elementID.substring(0,elementID.length-1);
			var flag = verif_mail(elementID,fieldname);
			if( flag ) flag = verifSame( elemCmpID, elementID, fieldname );
			break;
		case 'mail_optional':
			var flag = true;
			if( document.getElementById(elementID).value != '' ) flag = verif_mail(elementID,fieldname);
			break;
		case 'radio':
			var flag = verif_radio(elementID,fieldname);
			break;
		case 'select_date':
			var flag = verif_selected_date(elementID,fieldname);
			break;
		case 'phone':
			var flag = true;
			if( flag ) flag = verif_telephone(elementID,fieldname);
			break;
		case 'mobile':
			var flag = true;
			if( document.getElementById(elementID).value != '' ) {
				flag = verif_num( elementID,fieldname,10 )
				if( flag ) flag = verif_portable(elementID,fieldname);
			}
			break;
		case 'cp':
			var flag = true;
			if(document.getElementById('pays').value=='B' || document.getElementById('pays').value=='L' || document.getElementById('pays').value=='S' || document.getElementById('pays').value=='PT')
				nb = 4;
			else
				nb = 5;
			if(document.getElementById('pays').value != 'AD'){
				flag = verif_num( elementID,fieldname,nb );
			}
			if( flag ) flag = verif_zip( elementID, 'pays', fieldname,nb );
			break;
		case 'no_empty':
			var flag = verif_empty(elementID,fieldname);
			break;
		case 'borne_code' :
			var flag = verif_num(elementID,fieldname,6);
			break;
		case 'is_valid' : // Peremt de specifier que le champs sera toujours valid
			var flag = true;
			break;
	}

	var style = '';
	if( from == 'click' || elem == 'clientCivilite' ) {
		if( type == 'select_date' ) {
			elem = document.getElementById(elem+'J');
			if( elementID == 'newsletterDatenais' )
				style = 'style="margin-left:45px;"';
			else if(  elementID == 'clientDatenais') {
				style = 'style="margin-top:5px;margin-left:95px;"';
			} else if (elementID == 'garantieDateAchat') {
				style = 'style="margin: 5px 0 0 -10px"';
			}
			elementID += 'J';
		}
		else if( type == 'radio' ) {
			elem = document.getElementById(elem+'M');
			elementID += 'M';
			style = 'style="margin-left:307px;margin-top:4px;"';
		}
		else elem = document.getElementById(elem);
	}
	if( elementID == 'adresseTitre' && $.browser.webkit )
		style = 'style="margin:-22px 0 0 217px;"';

	if( !flag ) {
		if (blockMenuTopConnexionInfobulle != 1) {
			if ($('#' + elementID).closest('.formItem_container').children('img').length == 0) {
				$('#' + elementID).closest('.formItem_container').append('<img ' + style + ' src="'+path_relative_root+'img/picto_panneau.png" alt="" class="img_error" />');
			}
			elem_img = $("#"+elementID).closest('.formItem_container').children('img')[0];
		} else {
			document.getElementById(elem.id+'Err').style.display = 'table-row';
			if( $("#bloc_erreur").css('display') == 'table-row' || $("#bloc_erreur").css('display') == 'block'|| $("#bloc_erreur").css('display') == 'table' ) {
				$("#bloc_erreur").css('display','none')
				clearTimeout(timer);
			}
		}
	}
	if( !flag && from != 'click' ) {
		if (blockMenuTopConnexionInfobulle != 1) {
			pos = getPos(elem_img);
			if( from == 'spe' && !already_mail ) document.getElementById('erreur_msg').innerHTML = document.getElementById(elementID + 'Err').innerHTML;
			$("#bloc_erreur").fadeIn(400);
			document.getElementById('bloc_erreur').style.position = 'absolute';
			document.getElementById('bloc_erreur').style.top = pos.y - (document.getElementById('bloc_erreur').offsetHeight-5) + 'px';
			pos_left_margin = 0;
			if( document.getElementById('content') )
				pos_left_margin = getPos(document.getElementById('content'));
			document.getElementById('bloc_erreur').style.left = (pos.x-pos_left_margin.x-14) + 'px';
			document.getElementById('bloc_erreur').style.zIndex = '1';
			window.clearTimeout(timer);
			timer = setTimeout("closeInfobulle('bloc_erreur')",2000);
		}
	}
	else if( from != 'click' ) {
		window.clearTimeout(timer);
		timer = setTimeout("closeInfobulle('bloc_erreur')",2000);
	}
	if( !flag ) {
		var val = document.getElementById('erreur_msg').innerHTML;
			if( elem_img && (elementID == 'clientPwd' || elementID == 'clientMail' || elementID == 'clientMailAuth' || elementID == 'clientMailAuth' || elementID == 'clientPwdAuth' || elementID == 'mailLost') && !already_mail && blockMenuTopConnexionInfobulle != 1 ) {
				elem_img.setAttribute('onmouseover',function(){ openInfobulle('bloc_erreur','spe',elem); })
				elem_img.onmouseover=function(){ openInfobulle('bloc_erreur','spe',elem);}
				elem_img.setAttribute('onmouseout',function(){ closeInfobulle('bloc_erreur'); });
				elem_img.onmouseout=function(){ closeInfobulle('bloc_erreur');}
			}
			else if (elem_img && blockMenuTopConnexionInfobulle != 1) {
                elem_img.setAttribute('onmouseover',function(){ OverPopup(this,val,'visible'); });
                elem_img.onmouseover=function(){ OverPopup(this,val,'visible');}
                elem_img.setAttribute('onmouseout',function(){ OverPopup(this,val,'none'); });
                elem_img.onmouseout=function(){ OverPopup(this,val,'none');}
			}
	}
	else {
		if (blockMenuTopConnexionInfobulle == 1) {
			document.getElementById(elem.id+'Err').style.display = 'none';
		}
		if( $("#"+elementID).parent().children("img").length>0 ) {
			$("#"+elementID).parent().children("img").remove(".img_error");
		}
		if( $("#"+elementID).hasClass('inputErr')) {
			$("#"+elementID).removeClass('inputErr');
			//Au cas ou elle existerait deja, pour etre sur de ne l'ajouter qu'une seule fois
			$("#"+elementID).removeClass('inputForm');
			$("#"+elementID).addClass('inputForm');
		}
		if( $("#"+elementID+'Label').hasClass('labelErr')) {
			$("#"+elementID+'Label').removeClass('labelErr');
			//Au cas ou elle existerait deja, pour etre sur de ne l'ajouter qu'une seule fois
			$("#"+elementID+'Label').removeClass('labelForm');
			$("#"+elementID+'Label').addClass('labelForm');
		}
		if( $("#bloc_erreur").css('display') == 'table-row' || $("#bloc_erreur").css('display') == 'block' ) {
			$("#bloc_erreur").css('display','none');
			clearTimeout(timer);
		}
		if( from != 'spe' && elem != 'clientCivilite' ) {
			elem.setAttribute('onfocus',function(){})
			elem.onfocus=function(){}
		}
	}
	return flag;
}
function checkAllForm(tabError, blockMenuTopConnexionInfobulle, path_relative_root,id_form, nosubmit)
{
	if (blockMenuTopConnexionInfobulle == undefined) {blockMenuTopConnexionInfobulle = 0;};
	var bool_error = true;
	if	(
				$("#bloc_erreur").css('display') == 'table-row'
			||	$("#bloc_erreur").css('display') == 'block'
			||	$("#bloc_erreur").css('display') == 'table'
		)
	{
		$("#bloc_erreur").css('display','none');
		clearTimeout(timer);
	}
	if ( tabError == 'message' )
	{
		var msg =  tinyMCE.getInstanceById('message').getBody().innerHTML;
		if (!msg || typeof msg.length == 'undefined' || msg.length < 13)
		{
			bool_error = false;
		}
		else
		{
			bool_error = true;
		}
	}
	else {

		for (var field in tabError) {

			field = tabError[field];

			if (!checkForm(field[0], field[1], field[2], 'click', blockMenuTopConnexionInfobulle) && bool_error) {

				bool_error = false;
			}
		}
	}

	if (!bool_error)
	{
		hideLoader();
	}
	else if ( id_form != '' && typeof(id_form) != 'undefined' && !nosubmit )
	{
		$('#'+id_form).submit();
	}
	return bool_error;
}
